import { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import './Share.css';

interface ShareProps {
  code: string;
}

export function Share({ code }: ShareProps) {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  const handleShare = useCallback(() => {
    try {
      // Encode code as base64 for URL hash
      const encoded = btoa(encodeURIComponent(code));
      const shareUrl = `${window.location.origin}${window.location.pathname}#code=${encoded}`;

      // Copy to clipboard
      navigator.clipboard.writeText(shareUrl).then(() => {
        setToastMessage('Lien copié! Partagez votre chef-d\'oeuvre!');
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
      }).catch(() => {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = shareUrl;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        setToastMessage('Lien copié! Partagez votre chef-d\'oeuvre!');
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
      });
    } catch (error) {
      setToastMessage('Zut alors! Impossible de copier le lien.');
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  }, [code]);

  return (
    <>
      <button className="share-btn" onClick={handleShare} title="Share code via URL">
        <svg className="share-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="18" cy="5" r="3"/>
          <circle cx="6" cy="12" r="3"/>
          <circle cx="18" cy="19" r="3"/>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
          <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
        </svg>
        Share
      </button>

      {showToast && createPortal(
        <div className="share-toast">
          {toastMessage}
        </div>,
        document.body
      )}
    </>
  );
}

// Utility function to decode code from URL hash
export function getCodeFromUrl(): string | null {
  const hash = window.location.hash;
  if (hash.startsWith('#code=')) {
    try {
      const encoded = hash.slice(6); // Remove '#code='
      const decoded = decodeURIComponent(atob(encoded));
      return decoded;
    } catch (error) {
      console.error('Failed to decode code from URL:', error);
      return null;
    }
  }
  return null;
}

// Utility function to clear code from URL hash
export function clearCodeFromUrl(): void {
  if (window.location.hash.startsWith('#code=')) {
    // Update URL without triggering a page reload
    history.replaceState(null, '', window.location.pathname);
  }
}
